module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "content content-padding"
  }, [_c('div', {
    staticClass: "title-with-selector h1-selector"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.menu ? _vm.menu.languages[0].pivot.name : null))]), _vm._v(" "), _c('state-selector', {
    attrs: {
      "selected": _vm.menu ? parseInt(_vm.menu.state_id) : null,
      "target": _vm.menu,
      "update": "menu-slides"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('b', [_vm._v("Texto do Botão [PT]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.parent_languages[0].pivot.popup_button : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.parent_languages[0].pivot.popup_button) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('b', [_vm._v("Texto do Botão [EN]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.parent_languages[1].pivot.popup_button : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.parent_languages[1].pivot.popup_button) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('b', [_vm._v("Texto do Botão [ES]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.parent_languages[2].pivot.popup_button : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.parent_languages[2].pivot.popup_button) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('b', [_vm._v("Texto do Botão [FR]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.parent_languages[3].pivot.popup_button : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.parent_languages[3].pivot.popup_button) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('b', [_vm._v("Título do Grupo [PT]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.languages[0].pivot.name : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.languages[0].pivot.name) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('b', [_vm._v("Título do Grupo [EN]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.languages[1].pivot.name : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.languages[1].pivot.name) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('b', [_vm._v("Título do Grupo [ES]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.languages[2].pivot.name : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.languages[2].pivot.name) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column is-3"
  }, [_c('b', [_vm._v("Título do Grupo [FR]")]), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.menu.parent_languages ? _vm.menu.languages[3].pivot.name : null))]), _vm._v(" "), (_vm.menu.parent_languages && !_vm.menu.languages[3].pivot.name) ? _c('div', {
    staticClass: "placeholder-slide-text"
  }, [_vm._v("não definido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('div', [_c('b', [_vm._v("Cor de Fundo")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-container-center"
  }, [_vm._v("\n              " + _vm._s(_vm.menu.background_color) + "\n              "), _c('div', {
    staticClass: "color-preview",
    style: ({
      backgroundColor: _vm.menu.background_color
    })
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('div', [_c('b', [_vm._v("Cor Caixa de Texto")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-container-center"
  }, [_vm._v("\n              " + _vm._s(_vm.menu.textbox_color) + "\n              "), _c('div', {
    staticClass: "color-preview",
    style: ({
      backgroundColor: _vm.menu.textbox_color
    })
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('div', [_c('b', [_vm._v("Cor do Texto")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-container-center"
  }, [_vm._v("\n              " + _vm._s(_vm.menu.text_color) + "\n              "), _c('div', {
    staticClass: "color-preview",
    style: ({
      backgroundColor: _vm.menu.text_color
    })
  })])])])]), _vm._v(" "), (_vm.menu.slug !== 'panorama') ? _c('div', {
    staticClass: "columns is-multiline"
  }, [(_vm.menu.background_path_1) ? _c('div', {
    staticClass: "column is-12"
  }, [_vm._m(0), _vm._v(" "), _c('figure', {
    staticClass: "image coach-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.coachImagePath + _vm.menu.background_path_1
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.menu.background_path_2) ? _c('div', {
    staticClass: "column is-12"
  }, [_vm._m(1), _vm._v(" "), _c('figure', {
    staticClass: "image coach-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.coachImagePath + _vm.menu.background_path_2
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.openSlideSetEditModal
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Editar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Background 1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Background 2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e77fbd6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slide/SubMenuInfo.vue
// module id = 333
// module chunks = 1